module.exports = __webpack_public_path__ + "img/rating-star-half.6db4439b.svg";